/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.FilterChirpService
 */
import * as References from './FilterChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.FilterChirpService#getAllFilterTypes
 */
export const GET_ALL_FILTER_TYPES_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_FilterChirpService_getAllFilterTypes';
export const GET_ALL_FILTER_TYPES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_FILTER_TYPES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllFilterTypesRpc, {
      timeout: ctx.timeout
    });
  }
});